<template>
  <div class="flex h-dvh flex-col items-center justify-center p-4">
    <div class="flex max-w-3xl flex-col items-center gap-6 text-center">
      <Image
        src="/images/layouts/default/states/maintenance/logo.svg"
        alt="Maintenance"
        class="size-40"
      />

      <div>
        <p class="mb-2 text-3xl font-bold">
          {{
            $t('layouts.default.state.maintenance.title', {
              organizationName: selectedOrganization.displayName,
            })
          }}
        </p>
        <div class="text-xl text-gray-600 dark:text-gray-300">
          <p>{{ $t('layouts.default.state.maintenance.subtitle') }}</p>
          <p>{{ $t('layouts.default.state.maintenance.contact-us') }}</p>
        </div>
      </div>

      <div class="flex items-center justify-center gap-4">
        <Select
          v-if="availableOrganizations.length > 0"
          v-model="organizationToSwitch"
          :placeholder="$t('layouts.default.state.maintenance.switch-organization.placeholder')"
          :options="availableOrganizations"
          option-label="displayName"
          option-value="urlPath"
          @change="switchOrganization"
        />

        <Button
          :label="$t('common.cta.logout')"
          @click="signOutUser"
        >
          <template #icon>
            <UiLucideIcon :icon="LogOut" />
          </template>
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LogOut } from 'lucide-vue-next'
import type { Organization } from '~/types/organizations'
import { useOrganizationsStore } from '~/store/organizations'

const organizationsStore = useOrganizationsStore()
const { selectedOrganization, organizations } = storeToRefs(organizationsStore)

const organizationToSwitch = ref<Organization | null>(null)
const availableOrganizations = computed(() =>
  organizations.value.filter(organization => !organization.isUnderMaintenance),
)
const switchOrganization = ({ value }: { value: string }) => {
  console.log('switchOrganization', value)
  navigateTo(`/${value}`)
}
</script>
